export const SCENES = {
  FIRST_LEVEL: "FirstLevel",
  SECOND_LEVEL: "SecondLevel",
  THIRD_LEVEL: "ThirdLevel",
  FOURTH_LEVEL: "FourthLevel",
  FIFTH_LEVEL: "FifthLevel",
  SIXTH_LEVEL: "SixthLevel",
} as const;
